import type { MeetingDetectionDTO } from "../api/types";
import { MEETING_TYPE_LABEL, avatarColor, formatClock } from "../utils/format";

interface AlertPanelProps {
  detections: MeetingDetectionDTO[];
}

/** 会议未开启提醒区（数据来自 MISSED 状态的检测记录） */
export function AlertPanel({ detections }: AlertPanelProps) {
  const missed = detections.filter((d) => d.status === "MISSED");
  if (missed.length === 0) return null;

  return (
    <section className="alert-panel" aria-label="会议未开启提醒">
      <div className="alert-header">
        <div className="alert-title-row">
          <span className="alert-title">⚠️ 会议未开启提醒</span>
          <span className="badge">{missed.length} 场</span>
        </div>
        <span className="rule">超过应开时间 30 分钟未开启即触发 · 每分钟自动复检</span>
      </div>
      <div className="alert-list">
        {missed.map((m) => (
          <div className="alert-item" key={m.id}>
            <div className="avatar" style={{ background: avatarColor(m.hostName ?? m.deptName) }}>
              {(m.hostName ?? m.deptName)[0]}
            </div>
            <div className="info">
              <div className="dept">
                {m.deptName} · {MEETING_TYPE_LABEL[m.type] ?? m.type}
              </div>
              <div className="meta">
                <span>主持人：{m.hostName ?? "未指定"}</span>
                <span className="sep">·</span>
                <span>应于 {formatClock(m.expectedAt)} 开启</span>
                <span className="sep">·</span>
                <span className="overdue">已超时未检测到会议</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
